var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cfi-page" },
    [
      _c("div", { staticClass: "cfi-header" }, [
        _vm._m(0),
        _vm._v("\n    {{ integrationList }\n    "),
        _vm.integrationCount > 0
          ? _c("div", { staticClass: "cfi-header-meta" }, [
              _c("span", { staticClass: "cfi-enabled-badge" }, [
                _c("i", { staticClass: "el-icon-connection" }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.enabledCount) +
                    " / " +
                    _vm._s(_vm.integrationCount) +
                    " active\n      "
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.integrationCount === 0
        ? _c("div", { staticClass: "cfi-empty" }, [
            _c("i", { staticClass: "el-icon-connection cfi-empty-icon" }),
            _vm._v(" "),
            _c("p", [_vm._v("No integrations available for this form.")])
          ])
        : _c(
            "div",
            { staticClass: "cfi-grid" },
            _vm._l(_vm.integrationList, function(integration) {
              return _c(
                "div",
                {
                  key: integration.id,
                  staticClass: "cfi-card",
                  class: {
                    "cfi-card--enabled": integration.formenable,
                    "cfi-card--disconnected":
                      !integration.value || !integration.value.status
                  }
                },
                [
                  _c("div", { staticClass: "cfi-card-body" }, [
                    _c("div", { staticClass: "cfi-card-icon-wrap" }, [
                      integration.icon
                        ? _c("img", {
                            staticClass: "cfi-card-icon",
                            attrs: {
                              src: integration.icon,
                              alt: integration.title
                            }
                          })
                        : _c(
                            "span",
                            { staticClass: "cfi-card-icon-placeholder" },
                            [_c("i", { staticClass: "el-icon-connection" })]
                          )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cfi-card-info" }, [
                      _c("h4", { staticClass: "cfi-card-title" }, [
                        _vm._v(_vm._s(integration.title))
                      ]),
                      _vm._v(" "),
                      !integration.value || !integration.value.status
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "cfi-status-badge cfi-status-badge--disconnected"
                            },
                            [_vm._v("Not Connected")]
                          )
                        : _c(
                            "span",
                            {
                              staticClass: "cfi-status-badge",
                              class: integration.formenable
                                ? "cfi-status-badge--on"
                                : "cfi-status-badge--off"
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    integration.formenable
                                      ? "Enabled"
                                      : "Disabled"
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cfi-card-footer" },
                    [
                      integration.value && integration.value.status
                        ? [
                            _c(
                              "label",
                              { staticClass: "cfi-toggle-row" },
                              [
                                _c("el-switch", {
                                  on: {
                                    change: function($event) {
                                      return _vm.changeStatus(
                                        integration,
                                        $event,
                                        integration.id
                                      )
                                    }
                                  },
                                  model: {
                                    value: integration.formenable,
                                    callback: function($$v) {
                                      _vm.$set(integration, "formenable", $$v)
                                    },
                                    expression: "integration.formenable"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "cfi-toggle-label" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        integration.formenable
                                          ? "Active"
                                          : "Inactive"
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            integration.formenable
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "small",
                                      icon: "el-icon-setting"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.openDialog(integration)
                                      }
                                    }
                                  },
                                  [_vm._v("Configure")]
                                )
                              : _vm._e()
                          ]
                        : _c(
                            "span",
                            { staticClass: "cfi-not-connected-hint" },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning-outline"
                              }),
                              _vm._v(
                                " Configure in global settings first\n        "
                              )
                            ]
                          )
                    ],
                    2
                  )
                ]
              )
            }),
            0
          ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "580px",
            "custom-class": "cfi-dialog",
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [
                  _vm.dialogIntegration
                    ? _c("div", { staticClass: "cfi-dlg-header" }, [
                        _c("div", { staticClass: "cfi-dlg-header-icon" }, [
                          _vm.dialogIntegration.icon
                            ? _c("img", {
                                attrs: {
                                  src: _vm.dialogIntegration.icon,
                                  alt: _vm.dialogIntegration.title
                                }
                              })
                            : _c("i", { staticClass: "el-icon-connection" })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "cfi-dlg-header-text" }, [
                          _c("h3", { staticClass: "cfi-dlg-title" }, [
                            _vm._v(_vm._s(_vm.dialogIntegration.title))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "cfi-dlg-subtitle" }, [
                            _vm._v(
                              "Configure field mapping for this integration"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "cfi-dlg-close",
                            on: {
                              click: function($event) {
                                _vm.dialogVisible = false
                              }
                            }
                          },
                          [_c("i", { staticClass: "el-icon-close" })]
                        )
                      ])
                    : _vm._e()
                ]
              },
              proxy: true
            },
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "cfi-dialog-footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { plain: "" },
                          on: {
                            click: function($event) {
                              _vm.dialogVisible = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-check" },
                          on: { click: _vm.saveIntegration }
                        },
                        [_vm._v("Save Settings")]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _vm.dialogIntegration && _vm.dialogIntegration.formenable
            ? _c(
                "div",
                { staticClass: "cfi-dialog-body" },
                _vm._l(_vm.dialogIntegration.integration_fields, function(
                  field,
                  index
                ) {
                  return _c(
                    "div",
                    {
                      key: field.name || index,
                      staticClass: "cfi-dialog-field"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "cfi-dialog-field-header" },
                        [
                          _c("label", { staticClass: "cfi-dialog-label" }, [
                            _vm._v(_vm._s(field.label))
                          ]),
                          _vm._v(" "),
                          field.type === "list_ajax_options"
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: "text",
                                    icon: "el-icon-refresh"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.fetchlists(
                                        _vm.dialogIntegration,
                                        index
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Refresh")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      field.type === "text"
                        ? [
                            _c(
                              "div",
                              { staticClass: "cfi-input-wrap" },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: field.placeholder },
                                  model: {
                                    value:
                                      _vm.dialogIntegration.integration[
                                        field.name
                                      ],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dialogIntegration.integration,
                                        field.name,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dialogIntegration.integration[field.name]"
                                  }
                                }),
                                _vm._v(" "),
                                _c("merge_tags", {
                                  attrs: {
                                    field: field.name,
                                    name: _vm.dialogIntegration.id
                                  },
                                  on: { insert: _vm.insertValue }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      field.type === "list_ajax_options" ||
                      field.type === "select"
                        ? [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  filterable: "",
                                  clearable: "",
                                  placeholder:
                                    field.placeholder || "Select an option"
                                },
                                model: {
                                  value:
                                    _vm.dialogIntegration.integration[
                                      field.name
                                    ],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dialogIntegration.integration,
                                      field.name,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "dialogIntegration.integration[field.name]"
                                }
                              },
                              _vm._l(field.options, function(
                                list_name,
                                list_key
                              ) {
                                return _c("el-option", {
                                  key: list_key,
                                  attrs: { value: list_key, label: list_name }
                                })
                              }),
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      field.type === "checkbox-single"
                        ? [
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value:
                                    _vm.dialogIntegration.integration[
                                      field.name
                                    ],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dialogIntegration.integration,
                                      field.name,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "dialogIntegration.integration[field.name]"
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(field.checkbox_label) +
                                    "\n          "
                                )
                              ]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                }),
                0
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cfi-header-text" }, [
      _c("h2", { staticClass: "cfi-title" }, [_vm._v("Form Integrations")]),
      _vm._v(" "),
      _c("p", { staticClass: "cfi-subtitle" }, [
        _vm._v(
          "Connect this form to third-party services. Toggle an integration to activate it, then configure the mapping."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }